import { defineComponent as _defineComponent } from 'vue'
import { ConsultantMissionDeliverable } from "@/gql"
import useRouter from "@/router/useRouter"


export default /*#__PURE__*/_defineComponent({
  __name: 'PendingMissionDeliverables',
  props: {
    missionDeliverables: null
  },
  setup(__props: any) {



const { routes } = useRouter()

const getTagList = (missionDeliverable: ConsultantMissionDeliverable) => {
  return [
    missionDeliverable.missionStaffingPosition.name,
    missionDeliverable?.missionStaffingPosition?.missionLifecycle?.scopeService?.name,
    missionDeliverable?.missionStaffingPosition?.missionLifecycle?.scopeService?.serviceGroup?.name,
  ].filter(Boolean)
}

return { __sfc: true,routes, getTagList }
}

})